import _ from 'lodash'

/**
 * Sets up "nested model" relationship, where a parent Backbone.Model's property
 * is represented by a nested Backbone.Model. For example, WidgetModel has a properties
 * attribute, which is then nested as its own Model.
 *
 * This keeps the parent attribute and the nested model in sync, so that changes
 * to the nested model are reflected in the parent attribute, and vice versa.
 */
var nestModel = function (opt) {
	new Tracker(opt)
}

function Tracker (opt) {
	this.parent = opt.parent
	this.parentAttribute = opt.parentAttribute
	this.child = opt.child

	_.bindAll(this, 'onChange', 'onParentChange')

	this.listen()
}

_.extend(Tracker.prototype, {
	listen: function () {
		this.child.on('change', this.onChange)
		this.child.listenTo(this.parent, 'change:' + this.parentAttribute, this.onParentChange)
	},

	stopListening: function (){
		this.child.off('change', this.onChange)
		this.child.stopListening(this.parent, 'change:' + this.parentAttribute, this.onParentChange)
	},

	onChange: function () {
		this.stopListening()
		this.parent.set(this.parentAttribute, this.child.toJSON())
		this.listen()
	},

	onParentChange: function () {
		this.stopListening()

		// We want to totally "reset" all the attributes based on what's in the parent.
		// However, if we just do this.child.set(this.parent.get(this.parentAttribute)), any
		// properties that are no longer in the parent will be left alone (instead of
		// being unset/nulled). So create an object with all current properties set to
		// null, mix it with the parent property, and then any missing properties will
		// be properly nulled
		var nulledOut = _(this.child.attributes).keys().map(function (key) {
		  return [key, null]
		}).fromPairs().value()

		this.child.set(_.extend(nulledOut, this.parent.get(this.parentAttribute)))

		this.listen()
	}
})

export default nestModel

nestModel.__filename__ = 'components/nest-model.js'
